class Analytics {
	static clickEvent = (e) => {
		if (e.target.tagName !== 'A') e.preventDefault();
		if (window.tm)
			window.tm.event('click', e.target.innerText, {
				element: e.target,
				innerText: e.target.innerText,
			});
	};

	static pageViewEvent = (pageName, attr) => {
		if (window.tm) window.tm.event('pageView', pageName, attr);
	};

	static modalView = (modalName, attr) => {
		if (window.tm) window.tm.event('modalView', modalName, attr);
	};

	static formSubmitEvent = (formName, attr) => {
		if (window.tm) window.tm.event('formSubmit', formName, attr);
	};

	static errorEvent = (alertName, attr) => {
		if (window.tm) window.tm.event('alert', alertName, attr);
	};

	static customEvent = (eventName, attr) => {
		if (window.tm) window.tm.event('customEvent', eventName, attr);
	};

	static scanDOM = () => {
		if (window.tm) window.tm.scanDOM();
	};

	static init = () => {
		if (window.tm) window.tm.init();
	};
	static getSessionId = () => {
		if (window.tm) return window.tm.getSessionId();
	};

	static getVisitorId = () => {
		if (window.tm) return window.tm.getVisitorId();
	};

	static set = (key, value) => {
		if (window.tm) window.tm.set(key, value);
	};

	static get = (key) => {
		if (window.tm) return window.tm.get(key);
	};
}

export default Analytics;
